"use client"

import FocusLock from "react-focus-lock"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { NpProductImages } from "src/components/np-design/components/product-images/NpProductImages"
import { ResolvedAccessoryProductData } from "src/data/product-accessories-resolved/types"
import { formatPriceLong } from "src/utilities/price"

export type NpAccessoryDetailsModalProps = {
  accessory: ResolvedAccessoryProductData
  onClose: () => void
}

export const NpAccessoryDetailsModal = ({ accessory, onClose: close }: NpAccessoryDetailsModalProps) => {
  return (
    <FocusLock autoFocus returnFocus>
      <div className="z-add-to-cart-modal fixed inset-0 flex size-full items-center justify-center sm:p-8">
        <button
          type="button"
          tabIndex={-1}
          onClick={close}
          className="absolute inset-0 hidden size-full cursor-default bg-black/30 sm:block"
        />

        <div className="relative flex size-full flex-col items-center bg-white sm:size-auto sm:rounded-3xl sm:shadow-lg">
          <div className="fixed top-0 right-0 z-1 m-4 sm:absolute">
            <NpButton iconNameLeft="close" variant="ghost" color="gray75" size="md" onClick={close} title="Schließen" />
          </div>

          <div className="flex size-full flex-col items-center gap-8 overflow-y-auto p-8 pb-40 md:flex-row md:justify-center md:pb-8">
            <div className="w-full max-w-100">
              <NpProductImages name={accessory.name} images={accessory.images} />
            </div>

            <div className="flex flex-col items-start gap-4 md:w-100">
              <div className="font-product text-h2-np">{accessory.name}</div>
              <div className="text-h4-np">{formatPriceLong(accessory.price)}</div>
              {accessory.description && (
                <div className="text-base md:text-lg" dangerouslySetInnerHTML={{ __html: accessory.description }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </FocusLock>
  )
}
